export default "__VITE_PUBLIC_ASSET__1e6c60e4__"